module.exports = __webpack_public_path__ + "img/tradition@2x.0d5848f.webp";